import React, { useState } from "react";
import AlertHelper from "../../helpers/AlertHelper";
import ClosableCustomContentDialog, { IClosableCustomContentDialogProps } from "./ClosableCustomContentDialog";
import CustomAlertDialog, { ICustomAlertDialogProps } from "./CustomAlertDialog";
import CustomContentDialog, { ICustomContentDialogProps } from "./CustomContentDialog";
import CustomTextInputDialog, { ICustomTextInputDialogProps } from "./CustomTextInputDialog";
import CustomYesNoDialog, { ICustomYesNoDialogProps } from "./CustomYesNoDialog";
import CustomChoicesDialog, { ICustomChoicesDialogProps } from "./CustomChoicesDialog";
import ClosableCustomContentDialog2 from "./ClosableCustomContentDialog2";

export default function DialogDisplayers() {
  const [customAlertDialogProps, setCustomAlertDialogProps] = useState<ICustomAlertDialogProps>(
    {
      contentMessage: "",
      open: false,
      titleMessage: "",
      onClose: null,
      enableCloseOnEscOrBackClick: false,
    });

  const [customYesNoDialogProps, setCustomYesNoDialogProps] = useState<ICustomYesNoDialogProps>(
    {
      contentMessage: "",
      open: false,
      titleMessage: "",
      onClose: null,
      onYesClick: null,
      enableCloseOnEscOrBackClick: false,
    });

  const [customChoicesDialogProps, setCustomChoicesDialogProps] = useState<ICustomChoicesDialogProps>(
    {
      contentMessage: "",
      open: false,
      titleMessage: "",
      choices: [],
      onClose: null,
      onChoiceClick: null,
      enableCloseOnEscOrBackClick: false,
    });

  const [customTextInputDialogProps, setCustomTextInputDialogProps] = useState<ICustomTextInputDialogProps>(
    {
      contentMessage: "",
      open: false,
      titleMessage: "",
      onClose: null,
      onYesClick: null,
      isMultiLine: false,
      enableCloseOnEscOrBackClick: false,
    });

  const [customContentDialogProps, setCustomContentDialogProps] = useState<ICustomContentDialogProps>(
    {
      content: null,
      open: false,
      titleMessage: "",
      onClose: null,
      useFlex: false,
      enableCloseOnEscOrBackClick: false,
    });

  const [customContentDialogProps2, setCustomContentDialogProps2] = useState<ICustomContentDialogProps>(
    {
      content: null,
      open: false,
      titleMessage: "",
      onClose: null,
      useFlex: false,
      enableCloseOnEscOrBackClick: false,
    });

  const [closableCustomContentDialogProps, setClosableCustomContentDialogProps] = useState<IClosableCustomContentDialogProps>(
    {
      content: null,
      open: false,
      titleMessage: "",
      onClose: null,
      extraFullHeight: false,
      enableCloseOnEscOrBackClick: false,
    });

  const [closableCustomContentDialogProps2, setClosableCustomContentDialogProps2] = useState<IClosableCustomContentDialogProps>(
    {
      content: null,
      open: false,
      titleMessage: "",
      onClose: null,
      extraFullHeight: false,
      enableCloseOnEscOrBackClick: false,
    });

  AlertHelper.setCustomAlertDialogPropsMethod = setCustomAlertDialogProps;
  AlertHelper.setCustomYesNoDialogPropsMethod = setCustomYesNoDialogProps;
  AlertHelper.setCustomChoicesDialogPropsMethod = setCustomChoicesDialogProps;
  AlertHelper.setCustomTextInputDialogPropsMethod = setCustomTextInputDialogProps;
  AlertHelper.setCustomContentDialogPropsMethod = setCustomContentDialogProps;
  AlertHelper.setCustomContentDialogPropsMethod2 = setCustomContentDialogProps2;
  AlertHelper.setClosableContentDialogPropsMethod = setClosableCustomContentDialogProps;
  AlertHelper.setClosableContentDialogPropsMethod2 = setClosableCustomContentDialogProps2;

  return (
    <React.Fragment>
      <CustomAlertDialog
        titleMessage={customAlertDialogProps.titleMessage}
        contentMessage={customAlertDialogProps.contentMessage}
        open={customAlertDialogProps.open}
        onClose={customAlertDialogProps.onClose}
        enableCloseOnEscOrBackClick={customAlertDialogProps.enableCloseOnEscOrBackClick}
      />
      <CustomYesNoDialog
        titleMessage={customYesNoDialogProps.titleMessage}
        contentMessage={customYesNoDialogProps.contentMessage}
        open={customYesNoDialogProps.open}
        onClose={customYesNoDialogProps.onClose}
        onYesClick={customYesNoDialogProps.onYesClick}
        enableCloseOnEscOrBackClick={customYesNoDialogProps.enableCloseOnEscOrBackClick}
      />
      <CustomChoicesDialog
        titleMessage={customChoicesDialogProps.titleMessage}
        contentMessage={customChoicesDialogProps.contentMessage}
        open={customChoicesDialogProps.open}
        onClose={customChoicesDialogProps.onClose}
        onChoiceClick={customChoicesDialogProps.onChoiceClick}
        choices={customChoicesDialogProps.choices}
        enableCloseOnEscOrBackClick={customChoicesDialogProps.enableCloseOnEscOrBackClick}
      />
      <CustomTextInputDialog
        titleMessage={customTextInputDialogProps.titleMessage}
        contentMessage={customTextInputDialogProps.contentMessage}
        open={customTextInputDialogProps.open}
        onClose={customTextInputDialogProps.onClose}
        onYesClick={customTextInputDialogProps.onYesClick}
        isMultiLine={customTextInputDialogProps.isMultiLine}
        enableCloseOnEscOrBackClick={customTextInputDialogProps.enableCloseOnEscOrBackClick}
        initialText={customTextInputDialogProps.initialText}
      />
      <CustomContentDialog
        titleMessage={customContentDialogProps.titleMessage}
        content={customContentDialogProps.content}
        open={customContentDialogProps.open}
        onClose={customContentDialogProps.onClose}
        useFlex={customContentDialogProps.useFlex}
        enableCloseOnEscOrBackClick={customContentDialogProps.enableCloseOnEscOrBackClick}
      />
      <CustomContentDialog
        titleMessage={customContentDialogProps2.titleMessage}
        content={customContentDialogProps2.content}
        open={customContentDialogProps2.open}
        onClose={customContentDialogProps2.onClose}
        useFlex={customContentDialogProps2.useFlex}
        enableCloseOnEscOrBackClick={customContentDialogProps2.enableCloseOnEscOrBackClick}
      />
      <ClosableCustomContentDialog
        titleMessage={closableCustomContentDialogProps.titleMessage}
        content={closableCustomContentDialogProps.content}
        open={closableCustomContentDialogProps.open}
        onClose={closableCustomContentDialogProps.onClose}
        extraFullHeight={closableCustomContentDialogProps.extraFullHeight}
        enableCloseOnEscOrBackClick={closableCustomContentDialogProps.enableCloseOnEscOrBackClick}
      />
      <ClosableCustomContentDialog2
        titleMessage={closableCustomContentDialogProps2.titleMessage}
        content={closableCustomContentDialogProps2.content}
        open={closableCustomContentDialogProps2.open}
        onClose={closableCustomContentDialogProps2.onClose}
        extraFullHeight={closableCustomContentDialogProps2.extraFullHeight}
        enableCloseOnEscOrBackClick={closableCustomContentDialogProps2.enableCloseOnEscOrBackClick}
      />
    </React.Fragment>
  );
}
